module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7a464c190580fe09920f056945fd1fd8.png";